module.exports = __webpack_public_path__ + "img/PD2017489884331245568.2a695a5a.png";